module.exports = __webpack_public_path__ + "static/img/cabinate.494e964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cabinate.png
// module id = 34+R
// module chunks = 0